
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 100 80","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M55 7.5a7.5 7.5 0 0115 0 7.5 7.5 0 01-15 0zm20 17.36c2.766 0 5 2.374 5 5 0 2.906-2.234 5-5 5H65c-1.14 0-2.234-.25-3.125-1.094l-6.36-4.953-9.421 7.578 6.687 4.453A4.98 4.98 0 0155 45v20c0 2.766-2.234 5-5 5s-5-2.234-5-5V47.672l-9.453-5.984c-5.125-3.391-5.469-10.61-.672-14.313l12.984-10.047a7.513 7.513 0 019.235.047l9.656 7.484H75zM40 60c0 11.047-8.953 20-20 20C8.955 80 0 71.047 0 60s8.955-20 20-20c11.047 0 20 8.953 20 20zM20 48.75c-6.213 0-11.25 5.031-11.25 11.25S13.787 71.25 20 71.25c6.219 0 11.25-5.031 11.25-11.25S26.219 48.75 20 48.75zM100 60c0 11.047-8.953 20-20 20s-20-8.953-20-20 8.953-20 20-20 20 8.953 20 20zM80 48.75A11.243 11.243 0 0068.75 60c0 6.219 5.031 11.25 11.25 11.25S91.25 66.219 91.25 60 86.219 48.75 80 48.75z","fill":"currentColor"}})])
          )
        }
      }
    